import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardPopupService {

  constructor(private http: HttpClient) { }

  loadCriticalDiagCount(baseUrl: string, params: any): Observable<any> {
    return this.http.get<any>(`${baseUrl}/loadJsonObject?action_code=787b9e`, {
      params,
      withCredentials: true
    });
  }

  loadSubmissions(baseUrl: string, apiUrl: string, params: any): Observable<any> {
    return this.http.get<any>(`${baseUrl}${apiUrl}`, {
      params,
      withCredentials: true
    });
  }

  markAsReviewed(baseUrl: string, irsId: string): Observable<any> {
    const urlEncoded = new URLSearchParams();
    urlEncoded.set('irsId', irsId);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=rwh1ul`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  discardReturn(efileBaseUrl: string, submissionId: string, irsId: string): Observable<any> {
    return this.http.get<any>(
      `${efileBaseUrl}/discardReturn?submissionId=${encodeURIComponent(submissionId)}&irsId=${encodeURIComponent(irsId)}`,
      { withCredentials: true }
    );
  }

  downloadFile(efileBaseUrl: string, irsId: string, type: string): Observable<ArrayBuffer> {
    return this.http.get(
      `${efileBaseUrl}/downloadSubStatusDoc?irsId=${encodeURIComponent(irsId)}&type=${encodeURIComponent(type)}`,
      { responseType: 'arraybuffer', withCredentials: true }
    );
  }
}
